import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { contactKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useContacts = (params, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('contacts/search/'), {
            ...additional,
            params
        }),
        queryKey: contactKeys.listFor(params),
        enabled: enabled && !!params.q,
        staleTime: 30_000
    });
};
export default useContacts;
